export default __webpack_public_path__ + "static/media/devansh.7157df81.jpg";